// Design tokens for the Notification Center (WA-931), from the designer's spec
// ("Notification Center.dc.html"). Kept as one shared module so the sidebar bell, desktop modal,
// tablet popover and toast all draw from the same values instead of re-declaring hex codes.
export const notifTokens = {
  ink: '#0F172A',
  muted: '#64748B',
  faint: '#94a3b8',
  disabled: '#CBD5E1',
  hairline: '#ECEFF3',
  border: '#E3E7EC',
  canvas: '#F7F8FA',
  railBg: '#FAFBFC',
  rowHover: '#F5F6F8',
  rowUnread: '#FBFCFE',
  rowActive: '#EEF1F5',
  unreadDot: '#2563EB',
  badge: '#DC2626',
  scrim: 'rgba(15,23,42,.42)',
  bodyText: '#334155',
} as const

export const notifShadows = {
  card: '0 1px 3px rgba(15,23,42,.05)',
  toast: '0 8px 26px rgba(15,23,42,.13)',
  modal: '0 30px 90px rgba(15,23,42,.30)',
  popover: '0 20px 56px rgba(15,23,42,.14)',
} as const

// Breakpoint below which the desktop 3-pane modal degrades to a popover anchored to the bell.
export const NOTIF_DESKTOP_BREAKPOINT = 1180

// Status-chip tones for the preview column's object card (spec §2, "Object card" — e.g. "Awaiting
// dispatch" amber, "Assigned to you" violet, "Closed" slate). Independent of service tones — a
// status name here happens to reuse the same hex triples as a service tone, but the two systems
// are keyed differently (status label vs. service id) and shouldn't be merged.
export const STATUS_TONES: Record<string, { text: string; border: string; soft: string }> = {
  teal: { text: '#0F766E', border: '#B8E7E1', soft: '#F2FBFA' },
  violet: { text: '#6D28D9', border: '#DDD3FE', soft: '#F8F5FF' },
  blue: { text: '#1D4ED8', border: '#C7D7FE', soft: '#F5F8FF' },
  amber: { text: '#B45309', border: '#FCE4B6', soft: '#FFFBF2' },
  pink: { text: '#BE185D', border: '#F8CDE0', soft: '#FEF5F9' },
  slate: { text: '#475569', border: '#DFE4EA', soft: '#F6F7F9' },
}

export const getStatusTone = (tone: string) => STATUS_TONES[tone] ?? STATUS_TONES.slate
